import { useEffect, useState } from "react";

import { Footer, Header, Input, Messages, Sidebar } from "./components";
import { BotResponse, Message, MessageBody, MessageData } from "./interface";
import { getChatbotResponse } from "./utils";
import "./index.css";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { useDispatch, useSelector } from "react-redux";
import { setAccessToken, setUserId } from "./features/usersSlice";
import { RootState } from "./shared/store";
import { getChatHistoryApi } from "./utils/chatHistory";
import { clearChatHistoryApi } from "./utils/clearChatHistory";

const Dashboard: React.FC = () => {
  const dispatch = useDispatch();

  const { userId, accessToken } = useSelector(
    (state: RootState) => state.users
  );

  const [messages, setMessages] = useState<Message[]>([]);
  const [isResponseLoading, setIsResponseLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    getTokenAndId();
  }, []);

  useEffect(() => {
    if (userId && messages.length === 0) {
      setLoading(true);
      getChatHistory();
    }
  }, [userId]);

  const getTokenAndId = async () => {
    if (accounts.length > 0) {
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        dispatch(setAccessToken(response.idToken));

        // Decode the ID Token to extract the User ID (sub)
        const idToken = response.idToken;
        const decodedToken = await JSON.parse(atob(idToken.split(".")[1]));
        dispatch(setUserId(decodedToken.oid));
      } catch (error) {
        console.error("Error acquiring token:", error);
      }
    }
  };

  const getChatHistory = async () => {
    const response = await getChatHistoryApi(userId, accessToken);
    setMessages(response);
    setLoading(false);
  };

  const clearState = async () => {
    setMessages([]);
    await clearChatHistoryApi(userId, accessToken);
  };

  const send = async (text: string) => {
    const newMessages = messages.concat({
      bot_response: { response: "", sources: [] },
      user_query: text,
    });
    setMessages(newMessages);
    setIsResponseLoading(true);
    requestChatbotResponse({ text: text }, newMessages);
  };

  const requestChatbotResponse = async (
    message: MessageBody,
    newMessages: Message[]
  ) => {
    const response = await getChatbotResponse(
      message.text,
      accessToken,
      userId
    );
    setChatRequestResponse(response, newMessages);
    // return response.data;
  };

  const setChatRequestResponse = (
    data: BotResponse,
    newMessages: Message[]
  ) => {
    const lastRequest = newMessages[newMessages.length - 1];
    lastRequest.bot_response = data;
    setMessages([...newMessages]);
    setIsResponseLoading(false);
  };

  const toggleIsViewable = (index: number) => {};

  return (
    <div className="chatbot-container">
      <Sidebar />
      <div className="chatbot-content">
        <Header clearState={clearState} isNewChatDisabled={!messages.length} />
        {!loading && (
          <>
            <Messages
              messages={messages}
              toggleIsViewable={toggleIsViewable}
              requestChatbotResponse={requestChatbotResponse}
              isResponseLoading={isResponseLoading}
              onFaqPressed={send}
            />
            <Input onSend={send} isResponseLoading={isResponseLoading} />
          </>
        )}
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export { Dashboard };
